export function LoadingState({ label = "正在加载…" }: { label?: string }) {
  return <div className="state-panel" role="status"><span className="spinner" />{label}</div>;
}

export function ErrorState({ message, retry }: { message: string; retry?: () => void }) {
  return (
    <div className="state-panel error-panel" role="alert">
      <span>{message}</span>
      {retry && <button className="button secondary compact" type="button" onClick={retry}>重试</button>}
    </div>
  );
}

export function EmptyState({ title, detail }: { title: string; detail: string }) {
  return <div className="empty-state"><span className="empty-icon" aria-hidden="true">◎</span><h2>{title}</h2><p>{detail}</p></div>;
}
